export const WIDGET = 'widget';
export const GET_WIDGET = 'getWidget';
export const UPDATE_WIDGET = 'updateWidget';
